import axios, { AxiosError } from "axios";
import { FormikHelpers } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import apiConfig from "../../config/api_config";
import { pushCustomEvent } from "../../utils/customEventHelper";
import { setupAxiosRetry } from "../../utils/setupAxiosRetry";
import { InitialValues } from "./types";

type HandleForgotPasswordSubmit = (
  values: InitialValues,
  actions: FormikHelpers<InitialValues>,
) => Promise<void>;
type UseHandleForgotPasswordSubmit = () => {
  handleForgotPasswordSubmit: HandleForgotPasswordSubmit;
  isCoolingDown: boolean;
};
export const useHandleForgotPasswordSubmit: UseHandleForgotPasswordSubmit =
  () => {
    const { t, i18n } = useTranslation();
    const [isCoolingDown, setCoolingDown] = useState(false);

    const handleForgotPasswordSubmit: HandleForgotPasswordSubmit = async (
      values,
      actions,
    ) => {
      const { email } = values;
      setCoolingDown(true);
      try {
        setupAxiosRetry(axios);
        await axios.post(`${apiConfig.apiDomain}/password`, {
          email,
          language: i18n.language,
        });
      } catch (error) {
        const { response } = error as AxiosError;
        if (response?.status === 400) {
          actions.setErrors({
            apiResponse: t("error.validation.email.invalid"),
          });
        } else {
          actions.setErrors({
            apiResponse: t("passwordManagement.passwordResetGenericError"),
          });
        }
      }
      pushCustomEvent("resetPasswordRequest");

      setTimeout(() => setCoolingDown(false), 10000);
    };
    return { handleForgotPasswordSubmit, isCoolingDown };
  };
